(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jb-collector-hub"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('message',function(event){if(event.origin!=='https://jakes-breaks-showcase.earthy-crumb-2757.chatgpt.site'||event.data?.type!=='jakes-hub-height')return;document.querySelectorAll('.jb-collector-hub__frame').forEach(function(frame){if(frame.contentWindow!==event.source)return;const height=Number(event.data.height);if(Number.isFinite(height)&&height>=300&&height<=50000)frame.style.height=Math.ceil(height)+'px';});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-ebay-listings"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-jb-ebay-carousel]').forEach(section => {
      if (section.dataset.carouselReady) return;
      section.dataset.carouselReady = 'true';
      const track = section.querySelector('.jb-ebay__grid');
      const cards = [...track.children];
      const toggle = section.querySelector('[data-ebay-toggle]');
      const position = section.querySelector('[data-ebay-position]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let playing = !reduced.matches;
      let hovering = false;
      let touching = false;
      let visible = false;
      let timer;
      const index = () => {
        const start = track.getBoundingClientRect().left;
        let closest = 0;
        let distance = Infinity;
        cards.forEach((card, i) => {
          const delta = Math.abs(card.getBoundingClientRect().left - start);
          if (delta < distance) { distance = delta; closest = i; }
        });
        return closest;
      };
      const update = () => { position.textContent = (index() + 1) + ' / ' + cards.length; };
      const move = (direction) => {
        const max = track.scrollWidth - track.clientWidth;
        const atEnd = track.scrollLeft >= max - 5;
        const atStart = track.scrollLeft <= 5;
        const width = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
        let left = track.scrollLeft + direction * width;
        if (direction > 0 && atEnd) left = 0;
        if (direction < 0 && atStart) left = max;
        track.scrollTo({ left, behavior: reduced.matches ? 'instant' : 'smooth' });
      };
      const sync = () => {
        clearInterval(timer);
        toggle.textContent = playing ? section.dataset.pauseLabel : section.dataset.playLabel;
        if (playing && !hovering && !touching && visible && !document.hidden && !section.contains(document.activeElement)) {
          timer = setInterval(() => {
            if (!section.isConnected) { clearInterval(timer); return; }
            move(1);
          }, 5000);
        }
      };
      section.querySelector('[data-ebay-prev]').addEventListener('click', () => { playing = false; sync(); move(-1); });
      section.querySelector('[data-ebay-next]').addEventListener('click', () => { playing = false; sync(); move(1); });
      toggle.addEventListener('click', () => { playing = !playing; sync(); });
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); playing = false; sync(); move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      section.addEventListener('mouseenter', () => { hovering = true; sync(); });
      section.addEventListener('mouseleave', () => { hovering = false; sync(); });
      section.addEventListener('focusin', sync);
      section.addEventListener('focusout', () => setTimeout(sync, 0));
      track.addEventListener('pointerdown', () => { touching = true; playing = false; sync(); });
      track.addEventListener('pointerup', () => { touching = false; sync(); });
      track.addEventListener('pointercancel', () => { touching = false; sync(); });
      document.addEventListener('visibilitychange', sync);
      reduced.addEventListener('change', () => { if (reduced.matches) playing = false; sync(); });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: 0.15 });
      observer.observe(section);
      update(); sync();
    });
  };
  init();
  document.addEventListener('shopify:section:load', () => init());
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-tag-grading"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jb-tag-grading')) {
    customElements.define('jb-tag-grading', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const dialog = this.querySelector('dialog');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        this.querySelector('[data-tag-open]').addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!dialog.open) dialog.showModal();
        }, options);
        this.querySelector('[data-tag-close]').addEventListener('click', () => dialog.close(), options);
        this.querySelector('[data-tag-continue]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
